import { ListModel } from "lib/models/list-models";

import { ListsActionTypes, ListType } from "./constants";

export interface ListsState {
  loading: boolean;
  error: string | null;
  creatingFavoriteList: boolean;
  yourLists: ListModel[];
  publicLists: ListModel[];
  sharedLists: ListModel[];
  sharedWithYouLists: ListModel[];
}

export type ListsAction =
  | { type: ListsActionTypes.SET_LOADING; payload: boolean }
  | { type: ListsActionTypes.SET_ERROR; payload: string | null }
  | { type: ListsActionTypes.SET_CREATING_FAVORITE_LIST; payload: boolean }
  | { type: ListsActionTypes.ADD_LIST; payload: { list: ListModel; listType: ListType } }
  | { type: ListsActionTypes.UPDATE_LIST; payload: { list: ListModel; listType: ListType } }
  | { type: ListsActionTypes.DELETE_LIST; payload: { listId: string; listType: ListType } }
  | { type: ListsActionTypes.UPDATE_LIST_ITEMS; payload: { listId: string; itemId: string; listType: ListType } }
  | { type: ListsActionTypes.SET_YOUR_LISTS; payload: ListModel[] }
  | { type: ListsActionTypes.SET_PUBLIC_LISTS; payload: ListModel[] }
  | { type: ListsActionTypes.SET_SHARED_LISTS; payload: ListModel[] }
  | { type: ListsActionTypes.SET_SHARED_WITH_YOU_LISTS; payload: ListModel[] };

export const initialState: ListsState = {
  loading: false,
  error: null,
  creatingFavoriteList: false,
  yourLists: [],
  publicLists: [],
  sharedLists: [],
  sharedWithYouLists: [],
};

export const listsReducer = (state: ListsState, action: ListsAction): ListsState => {
  switch (action.type) {
    case ListsActionTypes.SET_YOUR_LISTS:
      return { ...state, yourLists: action.payload, error: null };
    case ListsActionTypes.SET_PUBLIC_LISTS:
      return { ...state, publicLists: action.payload, error: null };
    case ListsActionTypes.SET_SHARED_LISTS:
      return { ...state, sharedLists: action.payload, error: null };
    case ListsActionTypes.SET_SHARED_WITH_YOU_LISTS:
      return { ...state, sharedWithYouLists: action.payload, error: null };
    case ListsActionTypes.SET_LOADING:
      return { ...state, loading: action.payload };
    case ListsActionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case ListsActionTypes.SET_CREATING_FAVORITE_LIST:
      return { ...state, creatingFavoriteList: action.payload };
    case ListsActionTypes.ADD_LIST:
      return { ...state, [action.payload.listType]: [...state[action.payload.listType], action.payload.list] };
    case ListsActionTypes.UPDATE_LIST:
      return {
        ...state,
        [action.payload.listType]: state[action.payload.listType].map((list) =>
          list.listId === action.payload.list.listId ? action.payload.list : list
        ),
      };
    case ListsActionTypes.DELETE_LIST:
      return {
        ...state,
        [action.payload.listType]: state[action.payload.listType].filter(
          (list) => list.listId !== action.payload.listId
        ),
      };
    case ListsActionTypes.UPDATE_LIST_ITEMS:
      return {
        ...state,
        [action.payload.listType]: state[action.payload.listType].map((list) =>
          list.listId === action.payload.listId
            ? {
                ...list,
                items: list.items?.filter((item) => item.taxonomyId !== action.payload.itemId) || [],
                fullItems: list.fullItems?.filter((item) => item.taxonomyId !== action.payload.itemId) || [],
                itemCount: Math.max(0, list.itemCount - 1),
              }
            : list
        ),
      };
    default:
      return state;
  }
};
